import api from 'api';

export function getRefundsList(params) {
  const statuses = params.refundStatuses;
  const apiParams = {
    identifierId: params.identifierId,
    orderDisplayId: params.orderDisplayId,
    customerId: params.customerId,
    caseId: params.caseId,
    ticketId: params.ticketId,
    refundStatuses: Array.isArray(statuses) ? statuses.join(',') : statuses,
    refundType: params.refundType,
    orderType: params.orderType,
    startDate: params.startDate,
    endDate: params.endDate,
    page: params.page || 1,
    limit: params.limit || 10,
  };

  const cleanParams = Object.fromEntries(
    Object.entries(apiParams).filter(([_, v]) => v != null && v !== '')
  );

  return api.get(`/order/refund/list`, { params: cleanParams });
}

export function submitPMApproval(payload) {
  return api.post(`/order/layer1/approval`, payload);
}

export function submitFinanceApproval(payload) {
  return api.post(`/order/layer2/approval`, payload);
}

export function submitProcessed(payload) {
  return api.post(`/order/refund/processed`, payload);
}

export function getSubscriptionRefundDetails(id) {
  return api.get(`/offline/subscriptionTransaction/details/${id}`);
}

export function initiateOfflineRefund(payload) {
  return api.post(`/offline/refund/initiate`, payload);
}

export function downloadRefundsList(params) {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v != null && v !== '')
  );
  return api.get(`/order/refund/list/download`, { params: cleanParams });
}

export function getTicketDetails(ticketId) {
  return api.get(`/get-ticket-details/${ticketId}`);
}
